<script lang="ts">
  import { onMount } from 'svelte';
  import type { ActivityActionResult, RealmRift } from '@rsvjelle/game-core';
  interface Props { rift: RealmRift; onOpen: () => ActivityActionResult }
  let { rift, onOpen }: Props = $props();
  let now = $state(Date.now());
  let seconds = $derived(Math.max(0, Math.ceil((rift.expiresAt - now) / 1000)));
  let horizontal = $derived(12 + Math.abs([...rift.id].reduce((sum, char) => sum + char.charCodeAt(0), 0)) % 66);
  onMount(() => {
    const timer = setInterval(() => { now = Date.now(); }, 250);
    return () => clearInterval(timer);
  });
</script>

<button class="realm-rift" type="button" style={`left:${horizontal}%`} onclick={onOpen} aria-label={`Open Realm Rift, ${seconds} seconds remaining`}>
  <span class="rift-core">◈</span><strong>REALM RIFT</strong><small>{seconds}s · tap to seal its reward</small>
</button>
